/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { createPopper } from '@cian/popper-fork';
import { filter } from 'ramda';
export function usePopper(props) {
  const {
    open,
    anchorRef
  } = props;
  const {
    placement,
    modifiers,
    strategy,
    onFirstUpdate
  } = props.options || {};
  const instanceRef = React.useRef(null);
  const popperRef = React.useRef(null);
  const instance = instanceRef.current;
  const state = instance && instance.state;
  const options = React.useMemo(() => {
    return filter(v => v !== undefined, {
      placement,
      modifiers,
      strategy,
      onFirstUpdate
    });
  }, [modifiers, onFirstUpdate, placement, strategy]);
  React.useEffect(() => {
    if (!open) {
      return;
    }
    return () => {
      if (instanceRef.current) {
        instanceRef.current.destroy();
        instanceRef.current = null;
      }
    };
  }, [open]);
  const tryOpen = React.useCallback(() => {
    const popperEl = popperRef.current;
    const anchorEl = anchorRef.current;
    if (!open || !anchorEl || !popperEl) {
      return;
    }
    if (instanceRef.current) {
      instanceRef.current.destroy();
      instanceRef.current = null;
    }
    instanceRef.current = createPopper(anchorEl, popperEl, options);
  }, [anchorRef, open, options]);
  const handleRef = React.useCallback(node => {
    popperRef.current = node;
    tryOpen();
  }, [tryOpen]);
  useIsomorphicLayoutEffect(() => {
    // Обновление позиции, на случай если компонент сместился
    if (instanceRef.current) {
      instanceRef.current.forceUpdate();
    }
  });
  return {
    ref: handleRef,
    attributes: state && state.attributes.popper,
    style: state && state.styles.popper
  };
}